export class Role {
  static RENTER = new Role(0);
  static LANDLORD = new Role(1);
  static ENTREPRENEUR = new Role(2);

  static ALL_ROLES = [Role.RENTER, Role.LANDLORD, Role.ENTREPRENEUR];

  id: number;

  constructor(id: number) {
    this.id = id;
  }

  static getRoleWithId(id: number): Role {
    if (id === 0) {
      return Role.RENTER;
    } else if (id === 1) {
      return Role.LANDLORD;
    } else if (id === 2) {
      return Role.ENTREPRENEUR;
    }
    return Role.RENTER;
  }
}

